import type { HandlerFn } from "../actions";
import { createDynamicGroupHandler } from "./peers/create_dynamic_group";
import { sendInviteHandler } from "./account/send_invite";

export type { HandlerFn };

const extraButtonHandlers: Record<string, HandlerFn> = {
  create_dynamic_group: createDynamicGroupHandler,
  send_invite: sendInviteHandler,
};

export function getExtraButtonHandler(name: string): HandlerFn | undefined {
  return extraButtonHandlers[name];
}
